import { motion } from "framer-motion";

export const AboutSection = ({ t }) => {
  return (
    <div className="grid lg:grid-cols-12 gap-10 font-mono">
      <div className="lg:col-span-7 space-y-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-[var(--text)]">
          <span className="text-[#FF5722]"># </span>
          {t.about.heading}
        </h2>
        {t.about.paragraphs.map((p, i) => (
          <motion.p
            key={i}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="text-[13px] leading-relaxed text-[var(--muted)] border-l-2 border-[var(--border)] pl-4 hover:border-[#FF5722]/50 transition-colors"
          >
            {p}
          </motion.p>
        ))}
      </div>
      <div className="lg:col-span-5">
        <div className="grid grid-cols-2 gap-px bg-[var(--border)]">
          {t.about.stats.map((s, i) => (
            <div
              key={i}
              data-testid={`about-stat-${i}`}
              className="bg-[var(--surface)] p-6 hover:bg-[var(--line-hover)] transition-colors"
            >
              <div className="text-3xl font-bold text-[#FF5722]">
                {s.value}
              </div>
              <div className="mt-1 text-[10px] tracking-[0.15em] uppercase text-[var(--muted)]">
                <span className="text-[var(--cm)]">**</span>
                {s.label}
                <span className="text-[var(--cm)]">**</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
